import classNames from 'classnames';
import i18next from 'i18next';
import { useCallback } from 'react';
import { Button, ButtonProps, DropdownButton, Nav } from 'yoso';
import { getResolvedLanguage, lngConfig } from '~/components/I18n/i18n';
import { useMember } from '~/components/Member/Member.hooks';
import { useUpdateSetting } from '~/components/Setting/Setting.hooks';
import styles from './LanguageButton.module.scss';

export const options = Object.values(lngConfig);

export type LanguageButtonProps = ButtonProps & {
  language?: string;
};
export const LanguageButton = ({
  className,
  language = getResolvedLanguage(),
}: LanguageButtonProps) => {
  const {
    data: { isLoggedIn },
  } = useMember();
  const { mutateAsync } = useUpdateSetting();
  const onButtonClick = useCallback(
    async (e) => {
      const { value } = e.target;
      if (isLoggedIn) {
        await mutateAsync({ language: value });
      }
      await i18next.changeLanguage(value);
    },
    [isLoggedIn, mutateAsync]
  );
  const option = lngConfig[language] || lngConfig.en;
  return (
    <DropdownButton
      className={classNames(styles.root, className)}
      title={option.label}
      variant="outlined"
      color="transparent"
      drop="top"
      align="end"
      size="xsmall">
      <Nav>
        {options.map(({ value, label }) => (
          <li key={value}>
            <Button
              className={classNames({
                active: value === option.value,
              })}
              value={value}
              variant="text"
              onClick={onButtonClick}>
              {label}
            </Button>
          </li>
        ))}
      </Nav>
    </DropdownButton>
  );
};
